export default {
  wikis: {},
  parents: {},
  currentItem: null,
  authorName: null,
};



// WEBPACK FOOTER //
// ./src/store/wiki/state.js